import LoginLogo from '@CS/assets/Login/logo.png';
import LoaderGif from '@CS/assets/Loader/loader.gif';
import LoaderLottie from '@CS/assets/Loader/loader.json';
import LoaderLogoAR from '@CS/assets/Loader/family-mode-logo-ar.png';
import LoaderLogoEN from '@CS/assets/Loader/family-mode-logo-en.png';

import Particle1 from '@CS/assets/Particles/particle1.png';
import Particle2 from '@CS/assets/Particles/particle2.png';

export const Particles = [Particle1, Particle2];

export const Loader = {
  Lottie: LoaderLottie,
  Gif: LoaderGif,
  LogoAR: LoaderLogoAR,
  LogoEN: LoaderLogoEN
};

export const Login = {
  Logo: LoginLogo
};
